import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./search.css";
const Search = () => {
  const [searchData, setSearchData] = useState({
    destination: "",
  });

  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!searchData.destination.trim()) {
      toast.warn("Vui lòng nhập địa điểm bạn muốn đến!");
      return;
    }
    navigate("/tour-search", { state: searchData });
  };

  return (
    <div className="search-container">
      <div className="search-card">
        <h5 className="search-title">Khám phá điểm đến của bạn</h5>
        <form onSubmit={handleSubmit} className="search-form">
          <div className="input-group">
            <span className="input-group-text">
              <i className="isax isax-location5"></i>
            </span>
            <input
              type="text"
              className="form-control search-input"
              name="destination"
              value={searchData.destination}
              onChange={handleInputChange}
              placeholder="Bạn muốn đi đâu? (VD: Hà Nội, Đà Nẵng...)"
            />
            <button type="submit" className="btn btn-primary search-btn">
              <i className="isax isax-search-normal me-2"></i>
              Tìm kiếm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Search;
